import { useTranslation } from 'react-i18next';

export const useTranslate = (path) => {
    const { t: translate, ...rest } = useTranslation(path);
    return {
        ...rest,
        translate
    };
};
